import * as APIClient from './APIClient';

export const fetch = async pubkey => {
  const response = await APIClient.get(`/v2/orders/${pubkey}`);
  return response.json();
};

export const post = (token, saveCard = false) => {
  return APIClient.postJson('/v2/orders', {
    payment: {
      token,
      save_card: saveCard,
    },
  });
};

export const postWithSavedPayment = cardPubkey => {
  return APIClient.postJson('/v2/orders', {
    // https://github.com/prosehair/prose-api/blame/be6c0c3ef88949376c9cecbfbeb63e660dc2094a/prose/public/serializers/v2/order.py#L315
    card_id: cardPubkey,
  });
};

export const postFreeOrder = () => APIClient.postJson('/v2/orders');

export const patchFeedback = (orderPubkey, payload) => {
  return APIClient.patchJson(`/v2/orders/${orderPubkey}/feedback`, payload);
};

export const patchSupplementsFeedback = (orderPubkey, payload) => {
  return APIClient.patchJson(`/v2/orders/${orderPubkey}/supplements_feedback`, payload);
};
